<div class="mat-typography text-center" style="padding: 20px;">
    <mat-icon class="mat-icon" aria-hidden="true" style="font-size: 48px; color: #ff9800;">warning</mat-icon>
    <h2 class="mat-headline">¡Atención!</h2>
    <p class="mat-body-1">Tu sesión está por expirar.</p>
    <p class="mat-body-2">Tiempo restante: {{ countdown }}s</p>

    <div style="margin-top: 20px;">
        <button mat-raised-button color="primary" (click)="extend()">
            Extender sesión
        </button>
        <button mat-flat-button color="warn" (click)="close()" style="margin-left: 10px;">
            Salir
        </button>
    </div>
</div>